/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BillingDocument } from '../models/billing-document';
import { completeBillingDocument } from '../fn/billing-document/complete-billing-document';
import { CompleteBillingDocument$Params } from '../fn/billing-document/complete-billing-document';
import { dismissBillingDocument } from '../fn/billing-document/dismiss-billing-document';
import { DismissBillingDocument$Params } from '../fn/billing-document/dismiss-billing-document';
import { getBillingDocumentFile } from '../fn/billing-document/get-billing-document-file';
import { GetBillingDocumentFile$Params } from '../fn/billing-document/get-billing-document-file';

@Injectable({ providedIn: 'root' })
export class BillingDocumentApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `completeBillingDocument()` */
  static readonly CompleteBillingDocumentPath = '/billing-document/{id}';

  /**
   * Complete the billing document with the dates and the communication.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `completeBillingDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  completeBillingDocument$Response(params: CompleteBillingDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<BillingDocument>> {
    const obs = completeBillingDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Complete the billing document with the dates and the communication.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `completeBillingDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  completeBillingDocument(params: CompleteBillingDocument$Params, context?: HttpContext): Observable<BillingDocument> {
    const resp = this.completeBillingDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BillingDocument>): BillingDocument => r.body)
    );
  }

  /** Path part for operation `getBillingDocumentFile()` */
  static readonly GetBillingDocumentFilePath = '/billing-document/{id}/supporting-document';

  /**
   * Retrieve the billing document supporting document file as PDF.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBillingDocumentFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBillingDocumentFile$Response(params: GetBillingDocumentFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = getBillingDocumentFile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve the billing document supporting document file as PDF.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBillingDocumentFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBillingDocumentFile(params: GetBillingDocumentFile$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.getBillingDocumentFile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `dismissBillingDocument()` */
  static readonly DismissBillingDocumentPath = '/billing-document/{id}/dismiss';

  /**
   * Dismiss a billing document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dismissBillingDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dismissBillingDocument$Response(params: DismissBillingDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<BillingDocument>> {
    const obs = dismissBillingDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Dismiss a billing document.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dismissBillingDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dismissBillingDocument(params: DismissBillingDocument$Params, context?: HttpContext): Observable<BillingDocument> {
    const resp = this.dismissBillingDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BillingDocument>): BillingDocument => r.body)
    );
  }

}
